var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHeartGrey = function SvgHeartGrey(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3248 1.79829C12.0197 1.49502 11.6575 1.25444 11.2589 1.0903C10.8602 0.926158 10.4329 0.841675 10.0013 0.841675C9.56981 0.841675 9.1425 0.926158 8.74383 1.0903C8.34516 1.25444 7.98294 1.49502 7.67787 1.79829L7.04474 2.4274L6.41161 1.79829C5.79538 1.18598 4.95961 0.841992 4.08813 0.841992C3.21666 0.841992 2.38088 1.18598 1.76466 1.79829C1.14844 2.4106 0.802246 3.24107 0.802246 4.10701C0.802246 4.97295 1.14844 5.80342 1.76466 6.41573L2.39779 7.04484L7.04474 11.6623L11.6917 7.04484L12.3248 6.41573C12.63 6.11259 12.8722 5.75268 13.0373 5.35654C13.2025 4.9604 13.2876 4.53581 13.2876 4.10701C13.2876 3.67821 13.2025 3.25362 13.0373 2.85748C12.8722 2.46134 12.63 2.10143 12.3248 1.79829Z",
    fill: "#949494"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHeartGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-grey.a6b8a86d8aa4066d9b0c405c7dcd61e1.svg";